"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.propTypes = void 0;
exports.propTypes = ['string', 'number', 'boolean', 'object', 'array', null];
//# sourceMappingURL=PropType.js.map